module.exports = __webpack_public_path__ + "img/MEDIA058.5d4bac53.jpg";